import * as api from '../api/bugs.api';
import { JiraIssue } from '../types/Bugs';

export const createBug = async (userEmail: string, application: string, siteCode: string): Promise<string> => {
  const reporterId = localStorage.getItem('reporterId');

  // Check if the value exists in local storage
  if (!reporterId) {
    throw new Error('Reporter ID not found in local storage');
  }
  const params = {
    userEmailId: userEmail,
  };
  const response: JiraIssue.CreateBug.Response = await api.createBug(params, {
    fields: {
      summary: 'Placeholder - Please Update',
      issuetype: JiraIssue.IssueType.Bug,
      project: JiraIssue.Project.BugFixes,
      customfield_10060: {
        value: application,
        child: {
          value: siteCode,
        },
      },
      customfield_10062: JiraIssue.CustomField.ChangeMe,
      reporter: { id: reporterId },
    },
  });
  const parsedData = JSON.parse(response.successMessages);
  const key = parsedData.key;
  return key;
};
